{
  "layout": {
    "docked": {
      "hCenter": {
        "px": 0
      }
    },
    "x": 0,
    "y": 85
  },
  "mobileHints": {
    "type": "MobileHints",
    "recommendedWidth": 280,
    "recommendedHeight": 187,
    "author": "studio"
  }
}
